import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import movieBanner from "../../../assets/img/movie-banner.jpg";
import '../index.css'
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
    partialVisibilityGutter: 40, // this is needed to tell the amount of px that should be visible.
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
     partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.
  },
  tablet: {
    breakpoint: { max: 1024, min: 480 },
    items: 1,
    partialVisibilityGutter: 30, // this is needed to tell the amount of px that should be visible.
  },
  mobile: {
    breakpoint: { max: 480, min: 0 },
    items: 1,
    partialVisibilityGutter: 0, // this is needed to tell the amount of px that should be visible.
  },
};

export default function MovieCarousel(props) {
  return (
    <>
    <div style={{background:'var(--dark)',padding:'10px'}}>
      <Carousel swipeable responsive={responsive} partialVisible={true} infinite>
      <div  className="movie-slide"><img src={movieBanner}/></div>
      <div  className="movie-slide"><img src={movieBanner}/></div>
      <div  className="movie-slide"><img src={movieBanner}/></div>
      <div  className="movie-slide"><img src={movieBanner}/></div>
      </Carousel>
      </div>
    </>
  );
}
